import RAvatar from './r-avatar/r-avatar.vue';
import RBadge from './r-badge/r-badge.vue';
import RButton from './r-button/r-button.vue';
import RButtonGroup from './r-button-group/r-button-group.vue';
import RCheckbox from './r-checkbox/r-checkbox.vue';
import RDateInput from './r-date-input/r-date-input.vue';
import RIcon from './r-icon/r-icon.vue';
import RIconButton from './r-icon-button/r-icon-button.vue';
import RImg from './r-img/r-img.vue';
import RInput from './r-input/r-input.vue';
import RFileUpload from './r-file-upload/r-file-upload.vue';
import RLoader from './r-loader/r-loader.vue';
import RModal from './r-modal/r-modal.vue';
import RMonthPicker from './r-month-picker/r-month-picker.vue';
import RMonthPickerInput from './r-month-picker/r-month-picker-input.vue';
import RPagination from './r-pagination/r-pagination.vue';
import RPopper from './r-popper/r-popper.vue';
import RRadio from './r-radio/r-radio.vue';
import RSelect from './r-select/r-select.vue';
import RTab from './r-tabs/r-tab.vue';
import RTabs from './r-tabs/r-tabs.vue';
import RTile from './r-tile/r-tile.vue';
import RToast from './r-toast/r-toast.vue';
import RToggle from './r-toggle/r-toggle.vue';
import RRepeater from './r-repeater/r-repeater.vue';
import RGrid from './r-grid/r-grid.vue';

export {
    RAvatar,
    RBadge,
    RButton,
    RButtonGroup,
    RCheckbox,
    RDateInput,
    RIcon,
    RIconButton,
    RImg,
    RInput,
    RFileUpload,
    RLoader,
    RModal,
    RMonthPicker,
    RMonthPickerInput,
    RPagination,
    RPopper,
    RRadio,
    RSelect,
    RTab,
    RTabs,
    RTile,
    RToast,
    RToggle,
    RRepeater,
    RGrid,
};
